import { TimeRangeProvider } from './time.range.provider';
import { Injectable } from '@angular/core';
import { UrlListener } from './url.listener';
import { NO_VALUE, ValuesExchangeProvider } from './values.exchange.provider';
import { TimeRange } from '../../models/time-range';
import { UserService } from '../user/user.service';

@Injectable()
export class UrlBasedTimeRangeProvider extends TimeRangeProvider {
  constructor(
    private readonly urlListener: UrlListener,
    valuesExchange: ValuesExchangeProvider,
    userService: UserService
  ) {
    super(valuesExchange, userService);
    this.urlListener.declareUrlParam({
      name: 'time_range',
      mandatory: true
    });
    this.urlListener.registerListener('time_range', this.handleUrlChange.bind(this));
  }

  public replaceTimeRange(timeRange: TimeRange): void {
    this.urlListener.updateUrlParam('time_range', timeRange.toJSON());
  }

  private handleUrlChange(value: unknown): void {
    if (value === NO_VALUE) {
      return;
    }
    if (!value) {
      if (this.urlListener.hasReturnUrl()) {
        return;
      }
      this.replaceTimeRange(this.getDefaultTimeRange());
      return;
    }
    const timeRange = TimeRange.fromJSON(value as any);

    this.notifyListeners(timeRange);
  }
}
